"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSiteUrlParams = void 0;
var GameSiteUrlParams;
(function (GameSiteUrlParams) {
    GameSiteUrlParams["TokenID"] = "tokenId";
    GameSiteUrlParams["Story"] = "story";
    GameSiteUrlParams["HideUI"] = "hideUI";
    GameSiteUrlParams["Autostep"] = "autostep";
    GameSiteUrlParams["ResetPlot"] = "resetPlot";
    GameSiteUrlParams["StoryId"] = "storyId";
    GameSiteUrlParams["WalletAddress"] = "walletAddress";
    GameSiteUrlParams["Template"] = "template";
    GameSiteUrlParams["StoryIndex"] = "storyIndex";
    GameSiteUrlParams["Nft"] = "nft";
    GameSiteUrlParams["Ai"] = "ai";
    GameSiteUrlParams["CommunityShortcut"] = "communityShortcut";
    GameSiteUrlParams["DeeplinkTimelineId"] = "deepTimelineId";
    GameSiteUrlParams["DeeplinkStoryId"] = "deepStepId";
    GameSiteUrlParams["DeeplinkChoiceId"] = "deepChoiceId";
})(GameSiteUrlParams = exports.GameSiteUrlParams || (exports.GameSiteUrlParams = {}));
//# sourceMappingURL=params.js.map